import $ from 'jquery';
import "./_jquery-ui.js";

//  init widget
import selectDate from "./select-date";
import selectAirport from "./select-airport";
import controlPassenger from "./control-passenger";
import submitSearch from "./submit-search";


let depDate = new selectDate({
		selectBlock: '.js_depDate',
		inputId: '#depDate'
	}),
	retDate = new selectDate({
		selectBlock: '.js_retDate',
		inputId: '#retDate'
	}),
	
	fromAirport = new selectAirport({
		selectBlock: '.js_airport-from',
		selectId: '#selectFrom'
	}),
	toAirport = new selectAirport({
		selectBlock: '.js_airport-to',
		selectId: '#selectTo'
	}),

	ctrPassenger = new controlPassenger({
		ad: {
			selectBlock: '.js_passenger-ad',
			inputId: '#ad'
		},
		ya: {
			selectBlock: '.js_passenger-ya',
			inputId: '#ya'
		},
		ch: {
			selectBlock: '.js_passenger-ch',
			inputId: '#ch'
		},
		inf: {
			selectBlock: '.js_passenger-inf',
			inputId: '#inf'
		}
	}),
	submit = new submitSearch({
		btnSelect: '.js_btn-submit'
	});

$('.c-widget').css('display','block');

$('.c-widget__buttonc').on('click', () => {
    $('.c-widget').toggleClass('close');
});


// WEBPACK FOOTER //
// ./widget/index.js